import type { LovAfDTO } from '@/features/api/extranet/dto/Demande/AF'
import { afService } from '@/features/services/demande'
import { buildDemandeStore } from '../shared'
import {
  getNaturesFichiersAf as getNaturesFichiers,
  propertyStatusConfiguration,
  reglesConfiguration,
} from '@/features/domaine/regles-akto/AF'

export const useDemandeAFStore = buildDemandeStore<'MODEL_AF', LovAfDTO>({
  model: 'MODEL_AF',
  typeDemande: 'Formation',
  module: 'demande',
  demandeService: afService,
  propertyStatusConfiguration,
  reglesConfiguration,
  getNaturesFichiers,
})
